<div class="container-fluid ter-container">
    <fap-party-table
                [parties]="globalRegistry.systemData.parties"
                (deleteParty)="deleteParty($event)">
    </fap-party-table>
</div>
